import React from 'react'
import { Container, Flex, Box, css, Text } from 'theme-ui'
import Icon from '@solid-ui-components/ContentIcon'
import ContentText from '@solid-ui-components/ContentText'
import Reveal from '@solid-ui-components/Reveal'
import Divider from '@solid-ui-components/Divider'
import ContentImages from '@solid-ui-components/Educabot/ContentImages'
import QuickSignupForm from '@solid-ui-components/QuickSignupForm'
import ContentButtons from '@solid-ui-components/ContentButtons/ContentButtons'
import WithDefaultContent from '@solid-ui-blocks/WithDefaultContent'
import ListItem from '@solid-ui-components/ListItem'

const styles = {
  items: {
    display: 'none',
    '@media (max-width: 765px)': {
      display: 'block',
      paddingLeft: '30px'
    },
  },
  title: {
    fontSize: 40,
    fontWeight: 600,
    lineHeight: '50px',
    color: '#2A205E',
    paddingBottom: '12px',
    '@media (max-width: 765px)': {
      fontSize: 30,
    },
    '@media (max-width: 500px)': {
      margin: 'auto'
    },
    '@media (max-width: 450px)': {
      lineHeight: '40px',
      marginBottom: '1rem'
    },
  },
  subTitle: { 
    fontSize: '18px',
    pt: '1rem',
    pb: '1.5rem',
    '@media (max-width: 500px)': {
      textAlign: 'center'
    }
  },
  contentTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    '@media (max-width: 991px)': {
      justifyContent: 'center',
      alignItems: 'baseline',
    },
    '@media (max-width: 765px)': {
      justifyContent: 'flex-start',
    },
  }
}

const HeroBlock01 = ({
  content: { text = [], images, buttons, form, icon, collection },
  reverse
}) => (
  <Container >
    <Flex
      sx={{
        alignItems: [null, null, null, `center`],
        flexDirection: [
          reverse ? 'column' : `column-reverse`,
          null,
          null,
          reverse ? `row-reverse` : `row`
        ]
      }}
    >
      <Box
        sx={{
          flexBasis: [null, null, null, `3/5`],
          [reverse ? 'ml' : 'mr']: [null, null, null, 5],
          position: `relative`,
          textAlign: `center`,
          mt: 5
        }}
      >
        <ContentImages
          content={{ images }}
          loading='eager'
          reverse={reverse}
          imagePosition='center'
        />
      </Box>
      <Box
        sx={{
          flexBasis: `2/5`,
          textAlign: [`left`, 'left', 'center', `left`]
        }}
      >
        <Reveal effect='fadeInDown'>
          <Box sx={styles.contentTitle}>
            <Icon content={icon} mr='2' size='10px' p='2' round />
            <Text sx={styles.title}>
              Simplificá
            </Text>
          </Box>
          <Box sx={styles.contentText}>
            {/* <ContentText content={text} /> */}
            <Text sx={styles.subTitle}>Contá con las aplicaciones que se utilizan en
              educación para potenciar tus clases.
              Ya no vas a necesitar cuentas y contraseñas en diferentes proveedores. <span style={{ fontWeight: 600 }}>¡Vas a tener todo en un solo lugar!</span></Text>
          </Box>
        </Reveal>
        {collection && (
          <>
            <Box sx={styles.items}>
              <Divider space={3} />
              <Reveal
                effect={reverse ? 'fadeInRight' : 'fadeInLeft'}
                duration={1.5}
              >
                {collection.map((props, index) => (
                  <>
                    <ListItem key={`item-${index}`} {...props} />
                    <Divider space={2} />
                  </>
                ))}
              </Reveal>
            </Box>
          </>
        )}
        {buttons && (
          <Reveal
            effect='fadeInRight'
            delay={1}
            css={css({ mb: [4, null, null, 0],
              '@media (max-width: 500px)': {
                textAlign: 'center'
              }
            })}
          >
            {buttons && (
              <>
                <ContentButtons content={buttons} />
              </>
            )}
          </Reveal>
        )}
        {form && (
          <Reveal
            effect='fadeInRight'
            delay={1}
            css={css({ mb: [4, null, null, 0] })}
          >
            <QuickSignupForm {...form} space={3} />
          </Reveal>
        )}
      </Box>
    </Flex>
  </Container>
)


export default WithDefaultContent(HeroBlock01)
